import { formatUint256Percent as formatPercent, formatters } from '@repo/utils'

export { formatters, formatUint256 } from '@repo/utils'

export const formatLTV = formatters.number.digits(2).readable().min(0).max(100).createOf()

/** Trailing zeros on, unlike the shared default — liquidation renders whole percentages as `50.00%`. */
export const formatUint256Percent = (value: bigint) => formatPercent(value, 2, true)
